<template>
<div class="chapter">
<div class="inner_page">
<h4 class="calibre8" id="pgepubid00006"><a id="CHAPTER_II">II</a></h4>
<p class="calibre11">It was with a mingled feeling of sadness and joy that Caroline,
sometimes on foot and sometimes in an omnibus, traversed all alone the
great city of Paris, where she had been reared in ease, and which she
had left ruined and broken as to her future, in the very flower of her
life. Let us recount in a few words, once for all, the grave, yet simple
events of which she has given some outlines to the Marchioness de
Villemer.</p>
<p class="calibre11">She was the daughter of a gentleman of Lower Brittany, settled in the
neighborhood of Blois, and of a Mlle de Grajac, a native of Velay.
Caroline hardly knew her mother. Madame de Saint-Geneix died the third
year of her marriage in giving birth to Camille, having exacted a
promise from Justine Lanion to spend several years with the motherless
children.</p>
<p class="calibre11">Justine Lanion—Peyraque, by marriage—was a robust and honest
peasant-woman of Velay, who consented to remain eight years with M. de
Saint-Geneix. She had been Caroline's nurse, and had afterward returned
to her own family, whence she was soon called back to give the milk of
her second child to the second daughter of her "dear lady." Thanks to
this faithful creature, Caroline and Camille knew the care and
tenderness of a second mother; still, Justine could not forget her
husband and her own children. She had, at last, to return to her
province, and M. de Saint-Geneix took his daughters to Paris, where they
were brought up in one of the convents then in fashion.</p>
<p class="calibre11">As he was not rich enough to live in Paris, he rented temporary
apartments there, to which he went twice a year for the Easter Holidays
and his daughters' vacations. These were also the worthy man's
vacations. He practised economy the rest of the year that he might
refuse nothing to his children in those days of patriarchal
merry-making. Then their time was absorbed wholly in strolls, concerts,
visiting the museums, excursions to the royal palaces or dinners,
ruinous in their expense,—veritable pleasurings of a life, full of
simple, paternal affection, indeed, but as imprudent as it well could
be. The good man idolized his daughters, who were both very beautiful
and as good as they were beautiful. It was a pleasant fancy with him to
see them going out for a walk, dressed with perfect taste, looking
fresher than their dresses and ribbons new from the shop; to display
their beauty in the light and sunshine of Paris, that brilliant city,
where he had few acquaintances, to be sure, but where the slightest
notice of some casual passer-by seemed more important than any amount of
provincial admiration. To make Parisians, real Parisian ladies, of these
two charming girls was the dream of his life. He would have spent his
whole fortune to accomplish this; and—he did so spend it.</p>
<p class="calibre11">This infatuated desire to taste the delights of life in Paris is a
species of fatality which had, a few years ago, taken possession not
only of the well-to-do people of the provinces, but of whole classes.
Every great foreign nobleman, also, howsoever little his cultivation,
rushed wildly to Paris, like a school-boy in vacation time, tore himself
away from its attractions with bitter regret, and passed the rest of the
year at home in devising measures to obtain the passport giving him
leave to return. Even to-day, if it were not for the severity of laws
which condemn Russians to Russia, and Poles to Poland, immense fortunes
would vie with one another in their eagerness to come and be swallowed
up in the pleasures of Paris.</p>
<p class="calibre11">The two young ladies each profited very differently by their elegant
education. Camille, the younger and the prettier of the two,—which is
saying a great deal,—entered heartily into the giddy tastes of her
father, whom she resembled in face and in character. She was
passionately fond of luxury, and it had never occurred to her that her
life could ever become unhappy. Mild and loving, but not very
intelligent, she became merely an accomplished young lady in the matters
of style, dress, and manners. Returning to the convent at the close of
her vacations, she passed three months languishing regretfully, the next
three working a little in order to please her sister, who would
otherwise find fault with her; and the rest of the term in dreaming
about her father's return and the pleasures it would bring.</p>
<p class="calibre11">Caroline, on the other hand, was more like her mother, who had been a
woman of seriousness and energy. Yet she was usually cheerful, and more
demonstrative even than her sister in the hearty enjoyment of their
freedom. She showed herself more eager to make the most of dress, of
their walks and their sightseeing, but she relished all in a different
way. She was far more intellectual than Camille, with no creative genius
for Art indeed, but yet deeply sensitive to all its true manifestations.
She was born appreciative; that is, she could express the unspoken
thought of another with brilliancy and refinement. She repeated poetry
or read music with a surprising mastery of both. She spoke little, but
always well, yet with a strange precision, as if her ideas were all
drawn from within. But whenever she received suggestions from outside
sources,—from books, music, or the stage,—she gave the written
thought a new radiance. She seemed to be the necessary instrument of
genius; within the limits of interpretation, this gift of hers might have
been genius itself, had it received its full development.</p>
<p class="calibre11">But this it never received. Caroline had commenced her education at ten
years of age; at seventeen it was wholly broken off. This is the way it
happened: M. de Saint-Geneix having an income of only twelve thousand
francs, and yet dreaming of a future for his daughters worthy of their
attractions, had entangled himself with pitiable ingenuousness in
speculations which were to quadruple his property, and which engulfed it
in instant ruin.</p>
<p class="calibre11">Very pale, and as if dazed by some powerful shock, he came one day to
Paris for his daughters. He took them to his little manor-house with no
explanation whatever, and complaining only of a slight fever. He lay
there ill for three months, and then died of grief, confessing his ruin
to his two future sons-in-law; for at the appearance of the young ladies
at Blois, many suitors presented themselves, and two of them had been
accepted.</p>
<p class="calibre11">The gentleman betrothed to Camille was a civil officer, a respectable
man, who was sincerely fond of her, and married her in spite of
everything. Caroline was engaged to a gentleman of property. He reasoned
more selfishly, plead the opposition of his family, and withdrew his
pretensions. Caroline was brave. Her weaker sister would have died of
grief; but she was not the one deserted. Weakness exacts respect oftener
than energy. Moral courage is something invisible, and it breaks down
silently. Killing a soul too leaves no trace. Therefore the strong are
always buffeted, and the weak are buoyed up always.</p>
<p class="calibre11">Fortunately for Caroline, her love had not been intense. Her heart,
which was naturally affectionate, had begun to feel some confidence and
sympathy; but the mysterious grief and the increasing illness of her
father very soon took such strong possession of her mind that she could
not permit herself to dwell much upon her own happiness. The love of a
noble young woman is a flower which opens in the sunshine of hope; but
all hopefulness on her own account was overshadowed by the feeling that
her father's life was swiftly gliding away. She saw in her betrothed
only a friend who would share with her the duty of weeping. Toward him
she felt gratitude and esteem; but grief stood in the way of elation and
enthusiasm. Passion had not had time to blossom.</p>
<p class="calibre11">Caroline was then rather bruised than broken by desertion. Her love for
her father was so great, and she mourned him so deeply, that the ruin of
her own future prospects seemed to her but a secondary grief. Though she
was not at all indignant, yet she was sensible of the injury, and while
she revenged herself only by forgetting, she preserved toward men a
certain vague resentment, which kept her from believing in love and from
listening to the flatteries addressed to her beauty up to the age at
which we now find her, cured, courageous, and sincerely believing
herself proof against all attraction.</p>
<p class="calibre11">It is unnecessary to recount the events of the years which we have just
made her pass over. All the world knows that the loss of a fortune,
small or great, does not become an accomplished fact visibly from one
day to the next. Settlements with creditors are attempted, a belief that
something may be saved from the wreck is entertained, a series of
uncertainties is passed through, of astonishments, hopes deferred, up to
the day when, seeing all efforts fruitless, the situation, good or bad,
is finally accepted. Camille was prostrated by this disaster, in which,
to the last moment, she refused to believe; but she was well married and
did not suffer any real hardship. Caroline, with more foresight, was
apparently less affected by the positive destitution which necessarily
fell upon her. Her brother-in-law would not entertain the thought of
their parting, and generously made her share the competence of his
family; but she understood perfectly that her support was gone, and her
pride increased on that account. Feeling that her sister lacked activity
and a sense of order, and seeing moreover that she would be subject from
year to year to the suffering and cares of maternity, Caroline became
the housekeeper, the nurse of the children, in short, the first
maid-servant of the little household, and into the austere duties of
this self-sacrifice she contrived to work so much grace, good sense, and
cheerfulness, that all was pleasant around her and she rendered more
good offices than she received. Then came the illness of her
brother-in-law, his death, the discovery of old debts which he had
concealed, intending to pay them off, gradually and easily, out of his
salary; in short, the embarrassment, anxiety, and trouble of Camille,
and, at last, the utter despondency and misery of the young widow.</p>
<p class="calibre11">We have seen that, for some time, Caroline had been hesitating between
the fear of leaving her sister alone and the desire to assist her by
some direct effort. There was, indeed, one wealthy gentleman, neither
young nor very gracious, who considered her a model housewife, and made
her an offer of marriage. Caroline felt, at first vaguely but afterwards
with sufficient clearness, that Camille wished her to sacrifice herself.
She then determined that she would indeed make the sacrifice, but in a
different way. She asked nothing better than to give up her freedom, her
independence, her time, her life; but to demand the offering up of
herself, soul and body, to procure a little more comfort for the
family,—this was too much. She pardoned in the mother her selfishness
as a sister, and without appearing to see it, she decided upon the
course which we have seen her take. She left Camille in a poor little
country home, rented in the neighborhood of Blois, and set out for
Paris, where we know she was kindly welcomed by Madame de Villemer,
whose history we have now also briefly to relate.</p>
<p class="calibre11">Every family has its sore spot, every fortune its open wound out of
which its life-blood and the very security of its existence may ebb
away. The noble family of Villemer had its skeleton in the wild
misdoings of the eldest son of the Marchioness. The first husband of the
Marchioness had been the Duke d'Aléria, a haughty Spaniard, with a
terrible disposition, who had made her as unhappy as she could be, but
who, after five stormy years, had left her an ample fortune, and a son
handsome, good-humored, and intelligent, though destined to become
thoroughly sceptical, royally prodigal, and miserably profligate.</p>
<p class="calibre11">Having married the Marquis de Villemer, and becoming a mother and widow
for the second time, the Marchioness found in Urbain, her second son, a
devoted, generous friend, as austere in his habits as his brother was
corrupt, rich enough by his paternal inheritance to prevent him from
grieving too much about his mother's ruin; for, at the time when we
begin our history of these three people, the Marchioness had little or
nothing left, thanks to the life which the young Duke had led.</p>
<p class="calibre11">At this period, the young Duke was a little over thirty-six years of
age, and the Marquis nearly thirty-three. The Duchess d'Aléria, as will
be seen, had lost little time in becoming the Marchioness de Villemer.
No one had blamed her for this. She was passionately attached to her
second husband. It is even said that she had loved him as far as she
might, in all honor and innocence, before her first widowhood. The
Marchioness had a generous nature and was somewhat excitable. And the
premature death of this second husband made her almost insane for one or
two years. She would not see any one, and even her own children became
almost like strangers to her. Seeing this, the relatives of both her
late husbands were disposed to set her aside and to take charge
themselves of the education of her sons; but, at this idea, the
Marchioness came to her senses. Nature made a great effort; her soul
rose above its sorrow, her motherly feeling awoke, and the passionate
crisis which made her cling to her two sons with tears and caresses,
restored her power of reasoning and the control of her will. She
remained an invalid, weak and prematurely old, a little peculiar in some
respects, yet highly energetic in her conduct, exemplary in her
affections, and truly noble in all her relations with the world. From
this time forth, she began to attract notice by the brightness of her
mind, which had been for a long time asleep as it were in the midst of
her sorrow and her love, but which now, at last, showed itself in the
form of courage.</p>
<p class="calibre11">What precedes has sufficiently established her position in this story.
We will now leave Caroline de Saint-Geneix to estimate as she
understands them the Marchioness and her two sons.</p>
<p class="center">LETTER TO MADAME CAMILLE HEUDEBERT.</p>
<p class="calibre13">Paris, March 15, 1845.</p>
<p class="calibre11">Yes, dear little sister, I am very well settled, as I have told you in
my preceding letters. I have a pretty room, a good fire, a fine
carriage, servants, and a well-furnished table. I have only to believe
myself rich and a Marchioness, since, scarcely ever out of the presence
of my old lady, I am necessarily a sharer in all the comforts of her
life.</p>
<p class="calibre11">But you reproach me with writing very short letters. It is because, up
to this time, I have had but a few moments to myself. In fact, the
Marchioness, who, I believe, wished to put me a little to proof, appears
now to be satisfied that I am quite sincerely devoted to her, and she
permits me to leave her at midnight. So I can chat with you without
having to sit up till four o'clock in the morning to do it, for the
Marchioness receives till two, and she kept me an hour afterward to
discuss the people whom we had just seen,—a task which, I will
confess to you as I confessed to her, began to be very wearisome to me. She
thought that I was, like her, a late riser. When she learned that I
always awoke at six o'clock in the morning, and could not get asleep
again, she generously respected that "provincial infirmity." So, morning
or evening, I shall be hereafter at your service, dear Camille.</p>
<p class="calibre11">Yes, I love this old lady, and I love her a great deal. She has a great
charm for me, and the influence which she exercises over my mind comes
especially from the sincerity and purity of her own. She is not without
prejudices, it is true, and she has many ideas which are not, and never
will be, mine; but she holds to these honestly, without anything like
hypocritical subterfuge, and the antipathies which she expresses are not
at all formidable; for even in her prepossessions her perfect integrity
is manifest.</p>
<p class="calibre11">And besides, during the three weeks in which I have seen the great
world,—since the Marchioness, without giving formal parties, receives
quite a number of visits every evening,—I have become aware of a
general eclipse, of which, in the remoteness of my province, I never
formed so complete an idea. I assure you that, with the best of manners
and a certain air of superiority, people here are as nearly nonentities
as they can possibly be. They no longer have opinions on anything; they
find fault with everything, and know the remedy for nothing. They speak
ill of everybody, and are nevertheless on the best terms with everybody.
There is no indignation about it, just merely scandal. They are always
predicting the greatest catastrophes, and they seem to enjoy the most
profound security. In a word, they are as empty and shallow as
fickleness, as weakness itself; and in the midst of these troubled
spirits and of these threadbare convictions, I love this old
Marchioness, so frank in her antipathies and so nobly inaccessible to
compromise. I seem to see a personage of another century, a sort of
female Duke de Saint-Simon, guarding the respect of rank as a religion,
and understanding nothing of the power of money against which feeble or
hypocritical protests are made around her.</p>
<p class="calibre11">And as far as I am concerned, you know the contempt of money goes a good
way. Our misfortunes have not changed me, for I do not call by the name
of money that sacred thing, the salary which I now earn here proudly and
even with a little haughtiness. That is duty, a guaranty of honor.
Luxury itself, when it is the continuation or the recompense of an
elevated life, does not inspire me with the philosophic disdain which
always conceals a trifle of envy; but wealth coveted, hunted up and
down, bought at the price of ambitious marriages, by the unwinding of
political conscience, by family intrigues about successions,—these
are what justly wear the villanous name of money, and on that point I agree
heartily with the Marchioness, who has no pardon for interested and
ill-suited marriages, and for all other insipid things, whether private
or public.</p>
<p class="calibre11">That is why the Marchioness without regret and without dread sees all
that she possesses fall day by day into a gulf. I have already said
something to you about that. I told you that the Duke d'Aléria, her
elder son, ruined her, while the younger, the Marquis, the son of her
last husband, came to her support with tender respect, and again placed
her upon a very comfortable footing.</p>
<p class="calibre11">I must now speak of these two gentlemen, of whom I have yet told you but
a few words. I have seen the Marquis from the first day of my
installation here. Every morning from noon to one o'clock, and every
evening from eleven till midnight, he passes with his mother. Besides,
he dines with her quite frequently. I have therefore had time to observe
him, and I imagine that I already know him tolerably well. He is a young
man who appears to me to have had no youth. His health is delicate, and
his mind, which is cultivated and elevated, is engaged in a struggle
against some secret grief, or a natural tendency to sadness. He could
not have an external appearance less striking at first sight, and
exciting more sympathy in proportion to the degree in which his face
reveals itself. He is neither tall nor short, neither handsome nor
homely. There is nothing negligent or studied in his style of dress. He
seems to have an instinctive aversion to everything which might draw
attention to the person. Yet one sees very soon that he is no ordinary
man. The few words which he says to you have a deep or delicate meaning,
and his eyes, when they lose the perplexity of a certain shyness, are so
handsome, so good, so intelligent, that I do not believe I ever met
their equals.</p>
<p class="calibre11">His conduct toward his mother is admirable and paints him at full
length. I saw him pay out several millions, all his personal fortune, to
discharge the rash debts of the elder son, and he never frowned, never
said a word, never showed any vexation or regret. The weaker she was
toward this ungrateful and graceless son, the more tender and devoted
and respectful was the Marquis. You see it is impossible not to esteem
this man, and, as for me, I feel a sort of veneration for him.</p>
<p class="calibre11">His conversation, too, is very agreeable. He scarcely speaks at all in
society; but in intimacy, when the first reserve is worn off, he talks
charmingly. He is not only a cultivated man, he is a well of science. I
believe he has read everything, for upon whatever subject you suggest,
he is interesting, and proves that he has sounded it to the bottom. His
conversation is so necessary to his mother, that when anything prevents
his accustomed visit or lessens its duration, she is restless, and, as
it were, out of her reckoning for the remainder of the day.</p>
<p class="calibre11">At first, as soon as I saw him come in the morning, I took it upon
myself to retire, and I did so the more readily, seeing that this
superior and therefore excessively modest man appeared embarrassed by my
presence. It was doing me great honor, to be sure; but at the end of
three or four days he had so far regained his tranquillity as to ask me
very kindly why he put me to flight. I should not have believed myself
authorised by that to restrain the confidential freedom of the son and
mother; but she herself begged me to stay, even insisting upon it, and
she afterward gave me with her habitual frankness her reason for so
doing. And here is that reason, which is a little singular:—</p>
<p class="calibre11">"My son is of a melancholy spirit," she said; "that, however, is not my
character. I am very much depressed or very animated, never dreamy, and
dreaminess in others irritates me a little. In my son it troubles or
afflicts me. I have never been able to resign myself to it. When we are
alone together it requires constant effort on my part to keep him from
falling into his reveries. When we are surrounded by fifteen or twenty
persons of an evening, he gives himself up to his thoughts without
restraint, and frequently maintains a complete reserve. To enjoy the
full flavor of his mind, which is my peculiar pleasure and greatest
happiness, nothing is more favorable than the presence of a third
person, especially if that third person is one of merit. The Marquis
then takes the trouble to be charming, at first out of politeness and
then little by little out of a fastidious desire to please, though he
may not suspect it himself. In fact, he is a man who needs to be drawn
away from his own reflections, and he is so perfect to me that I have
not the right or the wish to enter upon this contest openly, while the
presence of a person, who even without saying anything is supposed to
listen, forces him to exert himself; seeing that, if he fears to appear
a pedant by speaking too much, he fears still more to appear affected
when he forgets himself in thought. So, my dear, you will do us both a
great service in not leaving us too much alone."</p>
<p class="calibre11">"Nevertheless, Madame," I answered, "if you should have private matters
to speak about, how shall I know?"</p>
<p class="calibre11">Thereupon she promised that in such a case she would give me notice by
asking me <i class="calibre12">if the clock is not slow.</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?ece3e9ae